import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text/src/BpkText';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { FormattedMessage } from '../i18n/index';

import type { TranslationKey } from '@shared/constants/translations';
import type { PriceLevel } from '@shared/types/frontend/ubff/price-band';

import STYLES from './AtypicalDealsTitle.module.scss';

const cls = cssModules(STYLES);
type Props = {
  labelKey: TranslationKey;
  type: PriceLevel;
  small?: boolean;
};

const AtypicalDealsTitle = ({ labelKey, small = false, type }: Props) => {
  const cssType = type.toLowerCase().replaceAll('_', '-');

  return (
    <BpkText
      textStyle={small ? TEXT_STYLES.heading5 : TEXT_STYLES.heading4}
      className={cls('AtypicalDealsTitle__text')}
    >
      <FormattedMessage
        label={labelKey}
        data={{
          strong: {
            pair: '/strong',
            // eslint-disable-next-line react/no-unstable-nested-components
            format: (text: string) => (
              <span className={cls(`AtypicalDealsTitle--${cssType}`)}>
                {text}
              </span>
            ),
          },
        }}
      />
    </BpkText>
  );
};

export default AtypicalDealsTitle;
